<template>
  <div>
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>

    <section class="container-fluid platform header-contact">
      <div class="row gmap">
        <div class="col">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3983.9317274617915!2d101.57487631532719!3d3.1127660542418853!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31cc4db2c8b4d46f%3A0xdc661123e9b850d!2sAcceleFreight!5e0!3m2!1sen!2smy!4v1552710672358"
            frameborder="0"
            style="border:0"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </section>

    <section class="container-fluid platform call-contact">
      <div class="row">
        <div class="col col-platform">
          <h3>Corporate HQ</h3>
        </div>
      </div>
      <div class="row">
        <div class="col col-platform border-right">
          <h4>Address</h4>
          <p>First floor, Jalan SS15/4C, 47500 Subang Jaya, Selangor.</p>
        </div>
        <div class="col col-platform">
          <h4>Contact</h4>
          <p>+60 12 820 8565</p>
          <p>
            <a href="mailto:info@accelefreight.com">info@accelefreight.com</a>
          </p>
        </div>
      </div>
    </section>

    <section class="container-fluid platform">
      <div class="row">
        <div class="col col-platform">
          <h3>Contact us</h3>
        </div>
      </div>
      <div class="row">
        <div class="col col-platform col-form">
          <form>
            <div class="form-group">
              <div class="form-label">
                <label for="inputName">Name</label>
              </div>
              <div class="form-input">
                <input
                  type="text"
                  class="form-control"
                  id="inputName"
                  placeholder="Name"
                  v-model="contactUs.name"
                />
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">
                <label for="inputEmail">Email</label>
              </div>
              <div class="form-input">
                <input
                  type="email"
                  required
                  class="form-control"
                  v-model="contactUs.sender"
                  id="inputEmail"
                  placeholder="Email"
                />
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">
                <label for="inputPhone">Phone Number</label>
              </div>
              <div class="form-input">
                <input
                  type="tel"
                  required
                  class="form-control"
                  v-model="contactUs.phoneno"
                  id="inputPhone"
                />
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">
                <label for="inputQuestion">Questions</label>
              </div>
              <div class="form-input">
                <textarea
                  required
                  class="form-control"
                  id="inputQuestion"
                  rows="3"
                  v-model="contactUs.body"
                ></textarea>
              </div>
            </div>
            <a class="header-btn" @click="onSubmit">Submit</a>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import constant from "../../const";

export default {
  data() {
    return {
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 6000,

      contactUs: {
        recipients: constant.INFO_MAIL,
        name: null,
        sender: null,
        subject: null,
        body: null,
        phoneno: null,
      },
    };
  },

  methods: {
    onSubmit: function () {
      var response = null;
      // block the ui
      this.$root.blockUIshow = true;

      // validate
      if (this.contactUs.sender == null) {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = "invalid email address";
        this.$root.blockUIshow = false;
        return;
      }

      // validate
      if (this.contactUs.name == null) {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = "invalid name. Please enter your name";
        this.$root.blockUIshow = false;
        return;
      }

      // modify contactUs subject
      if (this.contactUs.phoneno) {
        this.contactUs.subject = `${this.contactUs.name} (${this.contactUs.phoneno}) Contacted Us`;
      } else {
        this.contactUs.subject = `${this.contactUs.name} Contacted Us`;
      }

      axios
        .post(constant.EMAIL_URL, this.contactUs)
        .then((resp) => (response = resp.data))
        .catch((err) => {
          response = err.response;
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = response;
          this.$root.blockUIshow = false;
        })
        .finally(() => {
          // console.log("response--> ", response);
          this.$root.blockUIshow = false;
          if (
            response != null &&
            response.status == constant.RESPONSE_STATUS_OK
          ) {
            // navigate to the thank you page
            this.$router.replace({
              name: "thankyou",
            });
            // this.showSnackbar = true;
            // this.snackbarColor = "success";
            // this.snackbarMsg =
            //   "Thank your for reaching out. Our customer service will be in touch with you soon.";
          } else {
            this.showSnackbar = true;
            this.snackbarColor = "error";
            this.snackbarTimeout = 10000;
            this.snackbarMsg =
              "There was a problem saving your message. You may reach out to us directly at info@accelefreight.com.";
          }
        });
    },
  },

  computed: {
    emailValid: {
      get() {
        return this.fields.email && this.fields.email.valid;
      },
    },
  },
};
</script>

<style>
.error-message {
  font-size: 80%;
  color: red;
  padding-left: 10px;
}
</style>
